import app from './app'
import kansas from './kansas'
import texas from './texas'
import navigation from './navigation'
import externalUrls from './externalUrls'
import customCookies from './customCookies'
import walletParams from './walletParams'
import errorHandlers from './errorHandlers'

export default {
  app,
  kansas,
  texas,
  navigation,
  externalUrls,
  customCookies,
  walletParams,
  errorHandlers
}



// WEBPACK FOOTER //
// ./src/config/index.js